import React, { useRef, useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next';

const BlockChart = props => {

  const canvasRef = useRef(null)

  const [hoverConnection, setHoverConnection] = useState()
  const [insertButtonStyle, setInsertButtonStyle] = useState()
  const [showInsertButton, setShowInsertButton] = useState()

  const draw = ctx => {
    const { t } = props;
    //console.log("connections render")

    const canvas = canvasRef.current

    if (canvas) {
      var ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      //console.log("connections clearRect")
      for (let i = 0; i < props.connections.length; i++) {
        const connection = props.connections[i];
        if (!connection.line) {
          continue
        }

        //console.log("draw line")
        const start = connection.line.start
        const end = connection.line.end
        ctx.beginPath();
        const xOffset = (start.x - end.x) / 100
        const yOffset = 30
        if (hoverConnection === connection) {
          ctx.strokeStyle = "#d01a62"
          ctx.lineWidth = 3
        }
        else {
          ctx.strokeStyle = "black"
          ctx.lineWidth = 1
        }
        // const headlen = 10
        // const dx = end.x - start.x;
        // const dy = end.y - start.y;
        // const angle = Math.atan2(dy, dx);
        // const tox = end.x + xOffset
        // const toy = end.y - yOffset
        // ctx.moveTo(start.x, start.y);
        // ctx.bezierCurveTo(start.x - xOffset, start.y + yOffset, end.x + xOffset, end.y - yOffset, end.x, end.y);
        // ctx.lineTo(tox - headlen * Math.cos(angle - Math.PI / 6), toy - headlen * Math.sin(angle - Math.PI / 6));
        // ctx.moveTo(tox, toy);
        // ctx.lineTo(tox - headlen * Math.cos(angle + Math.PI / 6), toy - headlen * Math.sin(angle + Math.PI / 6));

        if (connection.line.detour) {
          //alert (connection.line.detour)
          var d1 = connection.line.detour[0]
          var d2 = connection.line.detour[1]
          var arrow = { sx: start.x, sy: start.y, 
            cx1: d1.x, cy1: d1.y, 
            cx2: d2.x, cy2: d2.y, 
            ex: end.x, ey: end.y };

          drawCurvedArrow(ctx, arrow);
        } else {
          var arrow = { sx: start.x, sy: start.y, cx1: start.x - xOffset, cy1: start.y + yOffset, cx2: end.x + xOffset, cy2: end.y - yOffset, ex: end.x, ey: end.y };

          drawCurvedArrow(ctx, arrow);
        }


        //ctx.stroke()

        // if (hoverConnection === connection) {
        //   setInsertButtonStyle({
        //     position: "absolute",
        //     top: (canvas.offsetTop + start.y + (end.y - start.y) / 2 - 8.5) + "px",
        //     left: (canvas.offsetLeft + start.x + (end.x - start.x) / 2 - 8.5) + "px"
        //   });
        // }
      }
    }
  }

  const drawCurvedArrow = (ctx, bez) => {

    // calculate the ending angle of the curve

    var pointNearEnd = getCubicBezierXYatT(
      { x: bez.sx, y: bez.sy },
      { x: bez.cx1, y: bez.cy1 },
      { x: bez.cx2, y: bez.cy2 },
      { x: bez.ex, y: bez.ey }, 0.92);
    var dx = bez.ex - pointNearEnd.x;
    var dy = bez.ey - pointNearEnd.y;
    var endingAngle = Math.atan2(dy, dx);

    // draw the arrow shaft

    ctx.moveTo(bez.sx, bez.sy);
    ctx.bezierCurveTo(bez.cx1, bez.cy1, bez.cx2, bez.cy2, bez.ex, bez.ey);
    ctx.lineWidth = 1;
    ctx.stroke();

    // draw the arrow head

    var size = 3;

    const headlen = 5
    //ctx.moveTo(bez.ex, bez.ey);
    //alert(endingAngle)
    ctx.beginPath();
    ctx.lineWidth = 1;
    ctx.moveTo(bez.ex, bez.ey);
    ctx.lineTo(bez.ex - headlen * Math.cos(endingAngle - Math.PI / 6), bez.ey - headlen * Math.sin(endingAngle - Math.PI / 6));
    ctx.lineTo(bez.ex - headlen * Math.cos(endingAngle + Math.PI / 6), bez.ey - headlen * Math.sin(endingAngle + Math.PI / 6));
    ctx.lineTo(bez.ex, bez.ey);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    // ctx.beginPath();
    // ctx.save();
    // ctx.translate(bez.ex,bez.ey);
    // ctx.rotate(endingAngle);
    // ctx.moveTo(0,0);
    // ctx.lineTo(0,-size*2);
    // ctx.lineTo(size*3,0);
    // ctx.lineTo(0,size*2);
    // ctx.lineTo(0,0);
    // ctx.closePath();
    // ctx.fill();
    // ctx.restore();

  }

  // helper functions

  const getCubicBezierXYatT = (startPt, controlPt1, controlPt2, endPt, T) => {
    var x = CubicN(T, startPt.x, controlPt1.x, controlPt2.x, endPt.x);
    var y = CubicN(T, startPt.y, controlPt1.y, controlPt2.y, endPt.y);
    return ({ x: x, y: y });
  }

  // cubic helper formula at T distance
  const CubicN = (T, a, b, c, d) => {
    var t2 = T * T;
    var t3 = t2 * T;
    return a + (-a * 3 + T * (3 * a - a * T)) * T
      + (3 * b + T * (-6 * b + b * 3 * T)) * T
      + (c * 3 - c * 3 * T) * t2
      + d * t3;
  }

  const getInputButtonStyle = (connection) => {

    const canvas = canvasRef.current
    const start = connection.line.start
    const end = connection.line.end

    return {
      position: "absolute",
      top: (canvas.offsetTop + start.y + (end.y - start.y) / 2 - 8.5) + "px",
      left: (canvas.offsetLeft + start.x + (end.x - start.x) / 2 - 8.5) + "px"
    }
  }

  useEffect(() => {

    const canvas = canvasRef.current
    const context = canvas.getContext('2d')

    // if (!this.handleMouseMove) {
    //   this.handleMouseMove = this.handleMouseMove.bind(this)
    //   this.handleMouseClick = this.handleMouseClick.bind(this)
    // }

    draw(context)
  }, [draw])

  // const handleMouseClick = (e) => {
  //   if (hoverConnection) {
  //     props.onInsertBlock(hoverConnection)
  //   }
  // }
  const handleMouseMove = (e) => {
    for (let i = 0; i < props.connections.length; i++) {
      const connection = props.connections[i];
      if (!connection.line) {
        continue
      }
      if (!connection.line.detour && calcIsInsideThickLineSegment(connection.line.start, connection.line.end, { x: e.clientX - canvasRef.current.offsetLeft, y: e.clientY - canvasRef.current.offsetTop }, 10)) {
        setHoverConnection(connection)
        setShowInsertButton(true)
        return
      }
    }
    setShowInsertButton(false)
    setHoverConnection(undefined)
  }

  const calcIsInsideThickLineSegment = (line1, line2, pnt, lineThickness) => {
    var L2 = (((line2.x - line1.x) * (line2.x - line1.x)) + ((line2.y - line1.y) * (line2.y - line1.y)));
    if (L2 === 0) return false;
    var r = (((pnt.x - line1.x) * (line2.x - line1.x)) + ((pnt.y - line1.y) * (line2.y - line1.y))) / L2;

    //Assume line thickness is circular
    if (r < 0) {
      //Outside line1
      return (Math.sqrt(((line1.x - pnt.x) * (line1.x - pnt.x)) + ((line1.y - pnt.y) * (line1.y - pnt.y))) <= lineThickness);
    } else if ((0 <= r) && (r <= 1)) {
      //On the line segment
      var s = (((line1.y - pnt.y) * (line2.x - line1.x)) - ((line1.x - pnt.x) * (line2.y - line1.y))) / L2;
      return (Math.abs(s) * Math.sqrt(L2) <= lineThickness);
    } else {
      //Outside line2
      return (Math.sqrt(((line2.x - pnt.x) * (line2.x - pnt.x)) + ((line2.y - pnt.y) * (line2.y - pnt.y))) <= lineThickness);
    }
  }


  return <>
    <canvas ref={canvasRef}
      id="workflowCanvas"
      className="workflowCanvas"
      style={props.canvasStyle}
      width={props.canvasWidth}
      height={props.canvasHeight}
      onMouseMove={handleMouseMove}
    />
    {showInsertButton ?
      <button onClick={() => props.onInsertBlock(hoverConnection)}
        className="icon-button workflow-add-button"
        style={getInputButtonStyle(hoverConnection)}
        title={props.t("tip_block_insert")}><i className="fas fa-plus"></i></button>
      : ""}
  </>
}

export default withTranslation()(BlockChart)
